<template>
  <v-dialog v-model="show" transition="dialog-bottom-transition">
    <v-form>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Historial de Turnos</v-toolbar-title>
        </v-toolbar>

        <v-card-title
          >Historial de Turnos del Jugador: {{ nombrePaciente }}</v-card-title
        >
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="8" sm="4">
              <v-btn
                class="boton-ordenamiento"
                color="warning"
                dark
                @click="invertirOrdenamiento"
              >
                {{ textoOrdenamiento }}
              </v-btn>
              <v-timeline align-top dense>
                <v-timeline-item
                  v-for="turno in listaTurnos"
                  :key="turno.idTurno"
                  :color="buscarColor(turno)"
                  small
                >
                  <v-row>
                    <v-col cols="12" md="12" sm="4" class="pa-0">
                      <strong>Cancha: {{ turno.nombreCancha }}</strong>
                      <strong class="ml-2"
                        >Fecha y Hora: {{ turno.fechaTurnoString }} -
                        {{ turno.horaInicioString }}hs.</strong
                      >
                    </v-col>
                  </v-row>
                  <v-row class="mt-2">
                    <v-col cols="12" md="12" sm="4" class="pa-0">
                      <strong class="ml-2"
                        >Estado: {{ turno.estadoTurnoString }}</strong
                      >
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-col>
            <v-col cols="12" md="4" sm="4" style="position: relative">
              <v-timeline
                align-top
                dense
                style="position: sticky; left: 0; top: 30px"
              >
                <v-timeline-item color="green" small>
                  <v-row>
                    <v-col cols="12" md="12" sm="4" class="pa-0">
                      <strong>Turnos Futuros</strong>
                    </v-col>
                  </v-row>
                </v-timeline-item>
                <v-timeline-item color="blue" small>
                  <v-row>
                    <v-col cols="12" md="12" sm="4" class="pa-0">
                      <strong>Turnos del Día</strong>
                    </v-col>
                  </v-row>
                </v-timeline-item>
                <v-timeline-item color="pink" small>
                  <v-row>
                    <v-col cols="12" md="12" sm="4" class="pa-0">
                      <strong>Turnos Pasados</strong>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Salir</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from "@/axios-auth";
import moment from "moment";

export default {
  data() {
    return {
      listaTurnos: [],
      ordenamiento: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
    },
    idPaciente: {
      type: Number,
    },
    nombrePaciente: {
      type: String,
    },
  },
  computed: {
    show: {
      get() {
        this.buscarHistorialTurnos();
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    textoOrdenamiento() {
      return !this.ordenamiento
        ? "Ordenar de más antiguo a más nuevo"
        : "Ordenar de más nuevo a más antiguo";
    },
  },
  methods: {
    buscarColor(turno) {
      const fechaTurno = moment(turno.fechaTurno).startOf("day");
      const hoy = moment().startOf("day");

      if (fechaTurno.isSame(hoy)) {
        return "blue";
      } else if (fechaTurno.isAfter(hoy)) {
        return "green";
      } else {
        return "pink";
      }
    },
    async buscarHistorialTurnos() {
      try {
        const { data } = await axios.get("/Turnos/HistorialTurnos", {
          params: {
            idPaciente: this.idPaciente,
          },
        });
        this.listaTurnos = data.sort(
          (a, b) => new Date(b.fechaTurno) - new Date(a.fechaTurno)
        );
      } catch (error) {
        this.listaTurnos = [];
        console.log("error retrieving data", error);
      } finally {
      }
    },
    invertirOrdenamiento() {
      if (!this.ordenamiento) {
        this.listaTurnos = this.listaTurnos.sort(
          (a, b) => new Date(a.fechaTurno) - new Date(b.fechaTurno)
        );
      } else {
        this.listaTurnos = this.listaTurnos.sort(
          (a, b) => new Date(b.fechaTurno) - new Date(a.fechaTurno)
        );
      }
      this.ordenamiento = !this.ordenamiento;
    },
  },
};
</script>
<style>
.boton-ordenamiento {
  margin-bottom: 1rem;
  margin-top: 1rem;
  margin-left: 2.5rem;
}
</style>
